// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Follow ${i.handle} on TikTok`
};

const de_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Folge ${i.handle} auf TikTok`
};

const es_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Seguir a ${i.handle} en TikTok`
};

const fr_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Suivre ${i.handle} sur TikTok`
};

const fi_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Seuraa käyttäjää ${i.handle} TikTokissa`
};

const hi_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `TikTok पर ${i.handle} को फॉलो करें`
};

const ja_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `TikTokで${i.handle}をフォロー`
};

const nl_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Volg ${i.handle} op TikTok`
};

const pt_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Seguir ${i.handle} no TikTok`
};

const ro_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Urmărește ${i.handle} pe TikTok`
};

const th_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `ติดตาม ${i.handle} บน TikTok`
};

const ur_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.handle} کو ٹک ٹاک پر فالو کریں`
};

const zh_hant1_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `在 TikTok 上追蹤 ${i.handle}`
};

const da_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Følg ${i.handle} på TikTok`
};

const it_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Segui ${i.handle} su TikTok`
};

const vn_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Theo dõi ${i.handle} trên TikTok`
};

const ko_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `TikTok에서 ${i.handle} 팔로우하기`
};

const tr_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `TikTok'ta ${i.handle} hesabını takip et`
};

const lv_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Sekojiet ${i.handle} TikTok`
};

const ar_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `تابع ${i.handle} على تيك توك`
};

const bs_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Pratite ${i.handle} na TikToku`
};

const sl_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Sledite ${i.handle} na TikToku`
};

const id_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Ikuti ${i.handle} di TikTok`
};

const sv_widget_actions_follow_on_tiktok = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Följ ${i.handle} på TikTok`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ handle: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_actions_follow_on_tiktok = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_actions_follow_on_tiktok(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_actions_follow_on_tiktok", locale)
	if (locale === "en") return en_widget_actions_follow_on_tiktok(inputs)
	if (locale === "de") return de_widget_actions_follow_on_tiktok(inputs)
	if (locale === "es") return es_widget_actions_follow_on_tiktok(inputs)
	if (locale === "fr") return fr_widget_actions_follow_on_tiktok(inputs)
	if (locale === "fi") return fi_widget_actions_follow_on_tiktok(inputs)
	if (locale === "hi") return hi_widget_actions_follow_on_tiktok(inputs)
	if (locale === "ja") return ja_widget_actions_follow_on_tiktok(inputs)
	if (locale === "nl") return nl_widget_actions_follow_on_tiktok(inputs)
	if (locale === "pt") return pt_widget_actions_follow_on_tiktok(inputs)
	if (locale === "ro") return ro_widget_actions_follow_on_tiktok(inputs)
	if (locale === "th") return th_widget_actions_follow_on_tiktok(inputs)
	if (locale === "ur") return ur_widget_actions_follow_on_tiktok(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_actions_follow_on_tiktok(inputs)
	if (locale === "da") return da_widget_actions_follow_on_tiktok(inputs)
	if (locale === "it") return it_widget_actions_follow_on_tiktok(inputs)
	if (locale === "vn") return vn_widget_actions_follow_on_tiktok(inputs)
	if (locale === "ko") return ko_widget_actions_follow_on_tiktok(inputs)
	if (locale === "tr") return tr_widget_actions_follow_on_tiktok(inputs)
	if (locale === "lv") return lv_widget_actions_follow_on_tiktok(inputs)
	if (locale === "ar") return ar_widget_actions_follow_on_tiktok(inputs)
	if (locale === "bs") return bs_widget_actions_follow_on_tiktok(inputs)
	if (locale === "sl") return sl_widget_actions_follow_on_tiktok(inputs)
	if (locale === "id") return id_widget_actions_follow_on_tiktok(inputs)
	if (locale === "sv") return sv_widget_actions_follow_on_tiktok(inputs)
	return "widget_actions_follow_on_tiktok"
};